(function () {
  var stickyFrame = null;
  var stickyEventsBound = false;

  function slugify(text) {
    return text.toLowerCase().trim().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '') || 'section';
  }

  function buildToc(root) {
    var content = root.querySelector('[data-gs-article-content]');
    var wrap = root.querySelector('[data-gs-toc-wrap]');
    var list = root.querySelector('[data-gs-toc]');
    if (!content || !wrap || !list) return;

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
    if (headings.length < 2) return;

    var used = {};
    headings.forEach(function (heading) {
      var base = heading.id || slugify(heading.textContent);
      var id = base;
      var suffix = 2;
      while (used[id] || (document.getElementById(id) && document.getElementById(id) !== heading)) {
        id = base + '-' + suffix++;
      }
      used[id] = true;
      heading.id = id;
      heading.style.scrollMarginTop = 'calc(var(--header-height, 10rem) + 2rem)';

      var li = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = heading.textContent;
      link.dataset.gsTocLink = id;
      li.appendChild(link);
      list.appendChild(li);
    });

    wrap.hidden = false;
  }

  function getVisibleHeaderBottom() {
    var bottom = 0;
    var candidates = document.querySelectorAll('.section-header, .shopify-section-header-sticky, sticky-header');

    Array.prototype.forEach.call(candidates, function (element) {
      var rect = element.getBoundingClientRect();
      if (rect.height <= 0 || rect.bottom <= 0 || rect.top >= window.innerHeight) return;
      bottom = Math.max(bottom, Math.min(rect.bottom, window.innerHeight));
    });

    if (bottom <= 0) {
      var cssHeaderHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
      if (isFinite(cssHeaderHeight) && cssHeaderHeight > 0) bottom = cssHeaderHeight;
    }

    return Math.max(12, Math.round(bottom + 14));
  }

  function updateTocCurrent(root) {
    var content = root.querySelector('[data-gs-article-content]');
    var list = root.querySelector('[data-gs-toc]');
    if (!content || !list) return;

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2[id]'));
    var links = list.querySelectorAll('[data-gs-toc-link]');
    if (!headings.length || !links.length) return;

    var activationLine = getVisibleHeaderBottom() + 24;
    var currentId = null;

    for (var i = 0; i < headings.length; i++) {
      if (headings[i].getBoundingClientRect().top <= activationLine) currentId = headings[i].id;
      else break;
    }

    links.forEach(function (link) {
      if (currentId && link.dataset.gsTocLink === currentId) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  }

  function clearManagedToc(wrap, nav) {
    if (!wrap || !nav) return;

    wrap.style.position = '';
    wrap.style.top = '';
    wrap.style.maxHeight = '';
    wrap.style.overflow = '';
    wrap.style.overscrollBehavior = '';
    wrap.style.minHeight = '';

    nav.style.position = '';
    nav.style.top = '';
    nav.style.left = '';
    nav.style.width = '';
    nav.style.zIndex = '';
    nav.style.margin = '';
    nav.style.opacity = '';
    nav.style.pointerEvents = '';
    nav.style.transition = '';
  }

  function updateManagedToc(root) {
    var wrap = root.querySelector('[data-gs-toc-wrap]');
    if (!wrap || wrap.hidden) return;

    var nav = wrap.querySelector('.gs-article__toc');
    var shell = root.querySelector('.gs-article__shell');
    if (!nav || !shell) return;

    if (window.innerWidth < 990) {
      clearManagedToc(wrap, nav);
      return;
    }

    /* Native sticky is intentionally disabled here. A tall sticky child is
       constrained by the bottom of its grid parent; near the end of the article
       the browser therefore pushes it upward, which visually clips its top.
       The wrapper remains in the grid as a placeholder while the TOC itself is
       fixed to the viewport. */
    wrap.style.position = 'relative';
    wrap.style.top = 'auto';
    wrap.style.maxHeight = 'none';
    wrap.style.overflow = 'visible';
    wrap.style.overscrollBehavior = 'auto';

    var stickyTop = getVisibleHeaderBottom();
    root.style.setProperty('--gs-article-sticky-top', stickyTop + 'px');

    var wrapRect = wrap.getBoundingClientRect();
    var shellRect = shell.getBoundingClientRect();
    var navHeight = nav.offsetHeight;
    var reachedTop = wrapRect.top <= stickyTop;
    var endBuffer = 24;
    var roomBelow = shellRect.bottom > stickyTop + navHeight + endBuffer;

    if (!reachedTop) {
      wrap.style.minHeight = '';
      nav.style.position = '';
      nav.style.top = '';
      nav.style.left = '';
      nav.style.width = '';
      nav.style.zIndex = '';
      nav.style.margin = '';
      nav.style.opacity = '';
      nav.style.pointerEvents = '';
      nav.style.transition = '';
      return;
    }

    wrap.style.minHeight = navHeight + 'px';
    nav.style.position = 'fixed';
    nav.style.top = stickyTop + 'px';
    nav.style.left = wrapRect.left + 'px';
    nav.style.width = wrapRect.width + 'px';
    nav.style.zIndex = '2';
    nav.style.margin = '0';
    nav.style.transition = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'none' : 'opacity 160ms ease';

    if (roomBelow) {
      nav.style.opacity = '1';
      nav.style.pointerEvents = '';
    } else {
      /* End the sticky state as a whole before the following article section.
         This is preferable to allowing the browser to shave the top of the TOC. */
      nav.style.opacity = '0';
      nav.style.pointerEvents = 'none';
    }
  }

  function updateAllManagedTocs() {
    document.querySelectorAll('.gs-article').forEach(function (root) {
      updateManagedToc(root);
      updateTocCurrent(root);
    });
  }

  function scheduleManagedTocs() {
    if (stickyFrame !== null) return;
    stickyFrame = window.requestAnimationFrame(function () {
      stickyFrame = null;
      updateAllManagedTocs();
    });
  }

  function bindManagedTocEvents() {
    if (stickyEventsBound) return;
    stickyEventsBound = true;
    window.addEventListener('scroll', scheduleManagedTocs, { passive: true });
    window.addEventListener('resize', scheduleManagedTocs);
  }

  function initShare(root) {
    var button = root.querySelector('[data-gs-share]');
    if (!button) return;
    var label = button.querySelector('[data-gs-share-label]');
    button.addEventListener('click', function () {
      var data = { title: document.title, url: window.location.href };
      if (navigator.share) {
        navigator.share(data).catch(function () {});
        return;
      }
      if (!navigator.clipboard) return;
      navigator.clipboard.writeText(window.location.href).then(function () {
        if (!label) return;
        var old = label.textContent;
        label.textContent = window.gsT('article.link_copied');
        window.setTimeout(function () { label.textContent = old; }, 1800);
      }).catch(function () {});
    });
  }

  function init() {
    document.querySelectorAll('.gs-article').forEach(function (root) {
      if (root.dataset.gsReady === 'true') return;
      root.dataset.gsReady = 'true';
      buildToc(root);
      initShare(root);
    });

    bindManagedTocEvents();
    scheduleManagedTocs();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () {
    init();
    scheduleManagedTocs();
  });
})();
